module.exports = __webpack_public_path__ + "img/dining-1.e8c91274.png";